import RequestManager from "src/requests/RequestManager";
import { Player } from "../interfaces";
import { isMockDataActive, lineup as resultMock } from "../mockData";
import { LineupTask } from "../tasks";
import { parsePlayer } from "../utils";

// Se usa en VCardPartido/Jugadores
export default async function getPlayersByMatch(matchId: string): Promise<{
    homePlayers:  Player[],
    awayPlayers: Player[],
    homeCoach: Player,
    awayCoach: Player
}> {
    const task = new LineupTask(matchId);
    let result;
    if(isMockDataActive) {
        result = resultMock;
    } else {
        result = await RequestManager.addRequest(task);
    }
    const home = result.homeLineup || {};
    const away = result.awayLineup || {};

    const homePlayers: Player[] = home.teamMembers && home.teamMembers.map((player: any) => parsePlayer(player)) || [];
    const homeCoach: Player = parsePlayer((home.coaches && home.coaches[0]) || {});

    const awayPlayers: Player[] = away.teamMembers && away.teamMembers.map((player: any) => parsePlayer(player)) || [];
    const awayCoach: Player = parsePlayer((away.coaches && away.coaches[0]) || {});

    return {
        homePlayers,
        awayPlayers,
        homeCoach,
        awayCoach
    }
};


// WEBPACK FOOTER //
// ./src/mundial/requests/api/getPlayersByMatch.ts